import { StyleSheet } from 'react-native';
import i18n from 'utils/i18n'
import Text from "theme/Text";
import Button from "theme/Button";
import ThemedSelect from 'components/atoms/ThemedSelect'
import _ from 'lodash'
import ThemedModal from 'components/atoms/ThemedModal'
import React, { useState } from 'react'
import MutateEmployeeBooking from 'utils/mutate/employee-booking'
import { bookingStatus } from 'utils/constants/booking-constants'


const ModalStatus = ({ visible = false, bookings, status, onHide, reload }) => {
	
	const [ saving, setSaving ] = useState( false )
	const [ newStatus, setNewStatus ] = useState( null )
	
	const booking = _.first( bookings );
	const invitation = _.get( booking, ['booking_invitation'], {} );
	const isInvitation = !_.isEmpty( invitation )
	
	const setVisible = () => {
		if( _.isFunction( onHide ) ) {
			onHide();
		}
	}
	
	// Create the select options
	const options = isInvitation ? [
		bookingStatus.INVITE_ACCEPTED,
		bookingStatus.INVITE_REJECTED,
	] :  [
		bookingStatus.ACTIVE,
		bookingStatus.CANCELLED,
	];
	
	const onStatus = () => {
		const bookingGuids = _.map( bookings, o => {
			return o.guid;
		} );
		
		MutateEmployeeBooking.status( bookingGuids, newStatus, {
			callbackStart: setSaving.bind( this, true ),
			callbackSuccess: ( { bookings } ) => {
				if( _.isFunction( reload ) ) {
					reload({
						withLoading: false
					});
				}
				
				setVisible( false )
				setSaving( false )
			},
			callbackError: setSaving.bind( this, false )
		})
	}
	
	return (
		<ThemedModal
			visible={ visible }
			setVisible={ setVisible.bind( this, false ) }
			title={ i18n.t('management:modal.status.title') }
			footer={(
				<>
					<Button
						appearance="ghost"
						onPress={ setVisible.bind( this, false ) }>
						
						{ i18n.t('management:modal.basic.cancel' ) }
					</Button>
					
					<Button
						isLoading={ saving }
						onPress={ onStatus.bind( this ) }>
						
						{ i18n.t('management:modal.status.button_confirm') }
					</Button>
				</>
			)}>
			
			<Text>
				{ i18n.t('management:modal.status.description', {
					current_status: i18n.t(`management:generic.booking.status.${status}` )
				}) }
			</Text>
			
			<ThemedSelect
				placeholder={ null }
				selected={ newStatus || status }
				options={(
					_.map( options, status => {
						return (
							{
								value: status,
								label: i18n.t(`management:generic.booking.status.${status}` )
							}
						);
					})
				)}
				select={ setNewStatus.bind( this ) }
				style={ staticStyles.themedSelectPaddingVertical4Width250 }
			/>
		</ThemedModal>
	)
}

const staticStyles = StyleSheet.create({
	themedSelectPaddingVertical4Width250: {
		paddingVertical: 4,
		width: 250,
	},
});

export default ModalStatus
